import { Rpc } from '@lightprotocol/stateless.js';
import { PublicKey } from '@solana/web3.js';

/**
 * Retrieves the total compressed balance for the given public key and mint address.
 *
 * @param publicKey - The owner's public key.
 * @param mintAddress - The mint address of the token.
 * @param connection - The RPC connection instance.
 * @returns The total compressed balance as a number.
 */
export const getTotalCompressedBalance = async (
  publicKey: PublicKey,
  mintAddress: PublicKey,
  connection: Rpc,
): Promise<number> => {
  const compressedBalances = await connection.getCompressedTokenBalancesByOwner(
    publicKey,
    {
      mint: mintAddress,
    },
  );
  return compressedBalances.items.reduce(
    (acc, item) => acc + Number(item.balance),
    0,
  );
};
